/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemDataTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System Data Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMDATATYPE_LIST_CONTAINER_LOADED,
    SYSTEMDATATYPE_LIST_CONTAINER_UNLOADED,
    SYSTEMDATATYPE_LIST_TABLE_LOADED,
    SYSTEMDATATYPE_LIST_TABLE_UNLOADED,
    SYSTEMDATATYPE_SELECT_ROW,
    SYSTEMDATATYPE_ADD,
    SYSTEMDATATYPE_EDIT,
    SYSTEMDATATYPE_DELETE,
    SYSTEMDATATYPE_OPEN_WARNING,
    SYSTEMDATATYPE_CLOSE_WARNING,
    SYSTEMDATATYPE_EDIT_CONTAINER_LOADED,
    SYSTEMDATATYPE_EDIT_CONTAINER_UNLOADED,
    SYSTEMDATATYPE_EDIT_FORM_LOADED,
    SYSTEMDATATYPE_EDIT_FORM_UNLOADED,
    SYSTEMDATATYPE_EDIT_DATA_LOAD,
    SYSTEMDATATYPE_EDIT_CONTAINER_SUBMIT,
    SYSTEMDATATYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeSystemDataTypes';

const defaultState = {
    refreshList: false,
    systemDataTypes: [],
    danger: false,
    systemdatatypeid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMDATATYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemdatatypes: action.payload ? action.payload.records : []
            }
        case SYSTEMDATATYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMDATATYPE_SELECT_ROW:
            return {
                ...state,
                systemdatatypeid: action.id
            }
        case SYSTEMDATATYPE_ADD:
            return {
                ...state
            }
        case SYSTEMDATATYPE_EDIT:
            return {
                ...state,
                systemdatatypeid: action.id
            }
        case SYSTEMDATATYPE_DELETE:
            return {
                ...state,
                systemdatatypeid: null
            }
        case SYSTEMDATATYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMDATATYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMDATATYPE_EDIT_CONTAINER_LOADED:
        case SYSTEMDATATYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                systemdatatypeid: action.payload ? action.payload.systemdatatypeid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case SYSTEMDATATYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMDATATYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMDATATYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMDATATYPE_LIST_CONTAINER_UNLOADED:
        case SYSTEMDATATYPE_LIST_TABLE_UNLOADED:
        case SYSTEMDATATYPE_EDIT_CONTAINER_UNLOADED:
        case SYSTEMDATATYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemDataTypes.js